import * as d3 from 'd3';
import React from 'react';
import styled from 'styled-components';

import useCommonContext from './hooks/useCommonContext';

const StyledAxis = styled.g``;
const StyledGrid = styled.g`
  opacity: 0.15;
`;

const defaultAxisFormat = { x: null, y: null };
const tickPadding = 8;

const Component = props => {
  const { axes, options, grid } = props;

  const axisFormat = options.axisFormat || defaultAxisFormat;

  const { width, height, margin, x, y } = useCommonContext();
  return (
    <g>
      {/* Y Axis */}
      {axes.y && (
        <StyledAxis
          style={{ transform: `translateX(${margin.left}px)` }}
          ref={g =>
            d3
              .select(g)
              .call(
                d3
                  .axisLeft(y)
                  .tickFormat(axisFormat.y)
                  .tickPadding(tickPadding)
                  .ticks(3)
              )
          }
        />
      )}
      {/* Horizontal Grid */}
      {grid.horizontal && (
        <StyledGrid
          style={{ transform: `translateX(${margin.left}px)` }}
          ref={g =>
            d3.select(g).call(
              d3
                .axisLeft(y)
                .tickFormat(d3.format(','))
                .ticks(5)
                .tickFormat('')
                .tickSize(-(width - margin.left - margin.right))
            )
          }
        />
      )}
      {/* X Axis */}
      {axes.x && (
        <StyledAxis
          style={{ transform: `translateY(${height - margin.bottom}px)` }}
          ref={g => {
            d3.select(g).call(
              d3
                .axisBottom(x)
                .ticks(3)
                .tickFormat(axisFormat.x)
                .tickPadding(tickPadding)
            );
          }}
        />
      )}

      {/* Vertical Grid */}
      {grid.vertical && (
        <StyledGrid
          style={{
            transform: `translateY(${height - margin.bottom}px)`,
          }}
          ref={g => {
            d3.select(g).call(
              d3
                .axisBottom(x)
                .ticks(3)
                .tickFormat('')
                .tickSize(-(height - margin.bottom - margin.top))
            );
          }}
        />
      )}
    </g>
  );
};

Component.defaultProps = {
  axes: { x: true, y: true },
  grid: { horizontal: false, vertical: false },
  options: {},
};

export default Component;
